import propTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';
import Paragraph from '../_generic/paragraph/Paragraph';

const VoucherRefundReasonList = ({
  handleSelectedOption,
  refundReasons,
  selectedRefundOption,
}) => {
  const theme = useContext(ThemeContext);
  const capitalizeFirstLetter = (input) => {
    return input?.charAt(0)?.toUpperCase() + input?.slice(1)?.toLowerCase();
  };

  return (
    <div>
      <ul className="list-item">
        {Object.keys(refundReasons).length > 0 &&
          Object.keys(refundReasons).map((value) => {
            return (
              <li className="refund-reason-flex" key={value}>
                <div className="input-container">
                  <input
                    checked={value === selectedRefundOption}
                    className="refund-reason-input"
                    id={value}
                    name="refund_reason"
                    onClick={() => handleSelectedOption(value)}
                    type="radio"
                    value={value}
                  />
                </div>
                <label className="refund-reason-label" htmlFor={value}>
                  <Paragraph type="caption">
                    {capitalizeFirstLetter(refundReasons[value])}
                  </Paragraph>
                </label>
              </li>
            );
          })}
      </ul>
      <style jsx>{`
        .list-item {
          list-style: none;
          padding: 0;
          border: 1px solid #c9cccc;
          border-radius: 5px;
          margin-bottom: 5%;
        }
        .refund-reason-label {
          width: 70%;
          margin-left: 6%;
          text-align: start;
        }
        .input-container {
          justify-content: center;
          width: 10%;
          margin-top: 2%;
        }
        .refund-reason-flex {
          border-bottom: 1px solid #c9cccc;
          padding: 3px;
          display: flex;
        }
        .refund-reason-input {
          /* Removed the default browser styles for radio buttons */
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          /* Use a custom style for the radio button */
          width: 15px;
          height: 15px;
          border: 1px solid #000;
          border-radius: 50%;
          outline: none;
        }
        .refund-reason-input:checked {
          background-color: #000;
        }
        ul li:last-child {
          border-bottom: none;
        }
        @media (min-width: ${theme.breakpoints.lgUp}) {
          .refund-reason-label {
            width: 85%;
            margin-left: 2%;
            font-size: 13px;
            margin-top: 1%;
          }
          .input-container {
            margin-top: 2%;
          }
        }
      `}</style>
    </div>
  );
};

VoucherRefundReasonList.propTypes = {
  handleSelectedOption: propTypes.func,
  refundReasons: propTypes.object,
  selectedRefundOption: propTypes.string,
};
export default VoucherRefundReasonList;
